import React from 'react'
import "./OrderSuccess.css"
import { useNavigate, useParams } from 'react-router-dom'

function OrderSuccess() {
    const { reference } = useParams();
    console.log('Reference:', reference);
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/")
    }
  return (
    <div className='order-success-back-container'>
        <div className="os-main-container">
            <div className="os-heading">
                <svg className='os-headin-message' viewBox="0 0 1320 300">
                    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                        Order Successfull
                    </text>
                </svg>
            </div>
            <div className="os-message">
                <span>Thank You For Visiting Us</span>
                <div>
                    <button onClick={() => handleClick()}>BACK TO HOME</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default OrderSuccess
